import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListGiftExchange = createAsyncThunk(
    "giftExchange/getListGiftExchange",
    async ({ currentPage, pageSize, mcouponBranchId, type, status, selectedDates}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/gift-exchanges?has_paginate&size=${pageSize}&page=${currentPage}`;
            if (mcouponBranchId) {
                apiUrl += `&mcoupon_branch_id=${mcouponBranchId}`;
            }
            
            if (type) {
              apiUrl += `&type=${type}`;
            }

            if (status) {
              apiUrl += `&status=${status}`;
            }
            
            if (selectedDates && selectedDates.length > 0) {
              apiUrl += `&start_date=${selectedDates[0]}&end_date=${selectedDates[1]}`;
            }

            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);

export const getByIdGiftExchange = createAsyncThunk(
  "giftExchange/getByIdGiftExchange",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await http.get(`/api/v1/serviceconnect/gift-exchanges/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Không tải được dữ liệu" });
    }
  }
);

export const updateGiftExchange = createAsyncThunk(
  "giftExchange/updateGiftExchange",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await http.put(`/api/v1/serviceconnect/gift-exchanges/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateImageGiftExchange = createAsyncThunk(
  "giftExchange/updateImageGiftExchange",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/gift-exchanges/upload-image/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createGiftExchange = createAsyncThunk(
  "giftExchange/createGiftExchange",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/gift-exchanges`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteGiftExchange = createAsyncThunk(
  "giftExchange/deleteGiftExchange",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/api/v1/serviceconnect/gift-exchanges/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const statusGiftExchange = createAsyncThunk(
  "giftExchange/statusGiftExchange", 
  async ({ id, data }, { rejectWithValue }) => { 
    try {
      const response = await http.put(`/api/v1/serviceconnect/gift-exchanges/status/${id}`, data); // Gọi API PUT
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GiftExchangeForCustomersApi = createAsyncThunk(
  "giftExchange/GiftExchangeForCustomersApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/gift-exchange-for-customers`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getListGiftExchangeForCustomerActive = createAsyncThunk(
  "giftExchange/getListGiftExchangeForCustomerActive",
  async ({ currentPage, pageSize, type}, { rejectWithValue }) => {
      try {
          let apiUrl = `/api/v1/serviceconnect/gift-exchange-for-customers/active?has_paginate&size=${pageSize}&page=${currentPage}`;
          if (type) {
            apiUrl += `&type=${type}`;
          }

          const response = await http.get(apiUrl);
          return response.data;
      } catch (error) {
          return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
      }
  }
);

export const getListGiftExchangeForCustomerHistories = createAsyncThunk(
  "giftExchange/getListGiftExchangeForCustomerHistories",
  async ({ currentPage, pageSize, mcouponBranchId, status, type, selectedDates}, { rejectWithValue }) => {
      try {
          let apiUrl = `/api/v1/serviceconnect/gift-exchange-for-customers/cms/histories?has_paginate&size=${pageSize}&page=${currentPage}`;
          if (mcouponBranchId) {
              apiUrl += `&mcoupon_branch_id=${mcouponBranchId}`;
          }

          if (status) {
            apiUrl += `&status=${status}`;
          }

          if (type) {
            apiUrl += `&type=${type}`;
          }

          if (selectedDates && selectedDates.length > 0) {
            apiUrl += `&start_date=${selectedDates[0]}&end_date=${selectedDates[1]}`;
          }
          
          const response = await http.get(apiUrl);
          return response.data;
      } catch (error) {
          return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
      }
  }
);

export const updateStatusGiftExchangeForCustomers = createAsyncThunk(
  "giftExchange/GiftExchangeForCustomersApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/gift-exchange-for-customers/update-status-sent`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);